const API_BASE = process.env.REACT_APP_IMS_API_BASE_URL || 'http://localhost:4001';

type IsUserAvailableResponse =
  | { status: number; message?: string }
  | any;

export async function isUserAvailable(email: string): Promise<boolean> {
  const trimmed = (email || "").trim().toLowerCase();
  if (!trimmed) return false;
  const url = `${API_BASE}/api/users/isUserAvailable/${encodeURIComponent(trimmed)}`;
  const res = await fetch(url, { method: "GET" });
  let data: IsUserAvailableResponse | null = null;
  try {
    data = await res.json();
  } catch {
    // ignore JSON parse error
  }
  if (res.ok && data && typeof data.status === "number") {
    return data.status === 200;
  }
  // fallback: if body missing, rely on HTTP
  return res.ok;
}
